import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


// const GetLearningInstruments = async (token, navigationSession) => {
//     try {
//         const dataToSend = {
//             "centerId": navigationSession.center.id,
//             "courseId": navigationSession.course.id,
//             "itemId": navigationSession.instrument.id
//         }
        
//         const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GetLearningInstruments", {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//             body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             //return { success: false, message: errorData.message || 'Error de autenticación' }
//             return { success: false, message: errorData.message } //errorCode
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         await LogErrors('GetLearningInstruments - DL Instruments', error)
//         return { success: false, message: '' }
//     }
// }

// const GetActivity = async (token, navigationSession) => {
//     try {
//         const dataToSend = {
//             "centerId": navigationSession.center.id,
//             "courseId": navigationSession.course.id,
//             "itemId": navigationSession.instrument.id
//         }
        
//         const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GetActivity", {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//             body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             //return { success: false, message: errorData.message || 'Error de autenticación' }
//             return { success: false, message: errorData.message } //errorCode
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         await LogErrors('GetActivity - DL Instruments', error)
//         return { success: false, message: '' }
//     }
// }

// const GetExam = async (token, navigationSession) => {
//     try {
//         const dataToSend = {
//             idCenter: navigationSession.center.id,
//             idCourse: navigationSession.course.id,
//             idItem: navigationSession.instrument.id
//         }
        
//         //const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GenerateTokenEvaluation", {
//         const response = await fetch(process.env.REACT_APP_API_URL + "/api/V4/Api/GenerateTokenEvaluation", {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//             body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             //return { success: false, message: errorData.message || 'Error de autenticación' }
//             return { success: false, message: errorData.message || 'No ha sido posible obtener la información de tu evaluación. Inténtalo nuevamente o inténtalo más tarde' } //errorCode
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         await LogErrors('GetExam - DL Instruments', error)
//         return { success: false, message: 'Ha habido un error al intentar obtener la información de tu evaluación. Inténtalo nuevamente o inténtalo más tarde' }
//     }
// }

const GetLearningInstruments = async (token, navigationSession) => {
    try {
        const dataToSend = {
            "centerId": navigationSession.center.id,
            "courseId": navigationSession.course.id,
            "itemId": navigationSession.instrument.id
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/Api/GetLearningInstruments"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GetLearningInstruments", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetLearningInstruments - DL Instruments', error)
        return { success: false, message: '' }
    }
}

const GetActivity = async (token, navigationSession) => {
    try {
        const dataToSend = {
            "centerId": navigationSession.center.id,
            "courseId": navigationSession.course.id,
            "itemId": navigationSession.instrument.id
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/Api/GetActivity"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
        
        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GetActivity", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetActivity - DL Instruments', error)
        return { success: false, message: '' }
    }
}

const GetExam = async (token, navigationSession) => {
    try {
        const dataToSend = {
            idCenter: navigationSession.center.id,
            idCourse: navigationSession.course.id,
            idItem: navigationSession.instrument.id
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V4/Api/GenerateTokenEvaluation"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // //const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GenerateTokenEvaluation", {
        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V4/Api/GenerateTokenEvaluation", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message || 'No ha sido posible obtener la información de tu evaluación. Inténtalo nuevamente o inténtalo más tarde' } //errorCode
        // }
        
        // const data = await response.json()
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetExam - DL Instruments', error)
        return { success: false, message: 'Ha habido un error al intentar obtener la información de tu evaluación. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { GetLearningInstruments, GetActivity, GetExam };